import { GiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/GiveawaySection';
import { RewardWinner } from 'root/src/client/web/giveaway/features/RewardWinner/RewardWinner';
import { GiveawayStats } from 'root/src/client/web/giveaway/features/GiveawayStats/GiveawayStats';
import { GiveawayRewards } from 'root/src/client/web/giveaway/features/GiveawayRewards/GiveawayRewards';
import { CreatorDataInfo } from 'root/src/client/web/record/CreatorData/CreatorDataInfo';
import { useIsBetaTester } from 'root/src/client/logic/api/hooks/useCreatorData';
export const CreatorData = () => {
    const isBetaTester = useIsBetaTester();
    return (<div className="flex flex-col" style={{ flex: 'initial', minHeight: 'initial !important' }}>
			<>
				<div className="flex flex-col gap-4 w-full max-w-large xl:px-12 justify-center self-center">
					<div className="flex flex-col md:flex-row gap-4 px-4 xl:px-0">
						<div className="flex CreatorTile">
							<CreatorDataInfo />
						</div>
						{isBetaTester && (<div className="flex flex-initial w-full md:w-2/5">
								<GiveawaySection />
							</div>)}
					</div>
					{isBetaTester && (<>
							<div className="beta flex flex-col sm:flex-row gap-4 px-4 xl:px-0 sm:items-start items-stretch w-full">
								<RewardWinner />
								<GiveawayStats />
							</div>
							<div className="mx-2">
								<GiveawayRewards />
							</div>
						</>)}
				</div>
			</>
		</div>);
};
